<skl-dialog-content-ins>
    <skl-dialog-header-ins
        [title]="data.title"
        (onClose)="onCancel()">
    </skl-dialog-header-ins>

    <ins-content>
        <div class="items">
            @for (item of data.items; track item) {
                <div
                    class="item"
                    [attr.data-label]="item.label | lowercase">
                    {{ item.value }}
                </div>
            }
        </div>
    </ins-content>
</skl-dialog-content-ins>